module.exports = __webpack_public_path__ + "img/icon-database.b05b770.png";